import { Country } from 'api-green-node';
import dayjs from './dayjsHelper';

/* User's Roles */
const roleOptionsPaygreen = ['ADMIN', 'USER', 'PAYGREEN', 'ASSOCIATION'];
const roleOptions = ['ADMIN', 'USER', 'ASSOCIATION'];
const roleDefault = roleOptions.USER;

/* Dates */
const startOfMonth = dayjs().startOf('month').format('DD/MM/YYYY');
const endOfMonth = dayjs().endOf('month').format('DD/MM/YYYY');

/* Donations Status */
const statusDonations = ['SUCCESS', 'REFUND'];

/* Partnerships Status Values used in BO */
const partnershipStatus = {
    ACTIVE: 'ACTIVE',
    CANCELLEDBYSHOP: 'CANCELLEDBYSHOP',
    CANCELLEDBYCHARITY: 'CANCELLEDBYCHARITY',
    PENDING: 'PENDING',
    REFUSED: 'REFUSED',
};

/* Partnerships Status Values from API */
const apiPartnershipStatus = {
    ACCEPT: 'ACCEPT',
    WAITING: 'WAITING',
    REFUSE: 'REFUSE',
    DELETE: 'DELETE',
};

/* PartnershipGroups Status Values */
const partnershipGroupStatus = {
    none: 'none',
    some: 'some',
    all: 'all',
};

/* PartnershipGroup Form modes */
const partnershipGroupFormModes = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
};

/* Login local status messages type */
const localLoginStatus = {
    success: 'success',
    warning: 'warning',
};

/* Login account error message modes */
const accountErrorModes = {
    notRegistered: 'notRegistered',
    notValidated: 'notValidated',
};

/* Sepa user Status */
const statusSepa = ['SIGNED', 'NOTSIGNED'];

/* Account user Status */
const statusActivation = ['CREATED', 'VALIDATED'];

/* Charity Stripe Account Status */
const stripeAccountActivation = ['VALIDATED', 'TOVALIDATE', 'TOCREATE', 'NONE'];
const stripeAccountModes = {
    VALIDATED: 'VALIDATED',
    TOVALIDATE: 'TOVALIDATE',
    TOCREATE: 'TOCREATE',
    NONE: 'NONE',
};

/* Spaces activated user Status */
const statusSpaces = ['CLIMATE', 'CHARITY', 'CLIMATECHARITY'];

/* Billing messages modes depending on environment and billing status */
const billingDisplayModes = {
    adress: 'adress',
    iban: 'iban',
};

/* Carbon Modes */
const carbonModes = { carbon: 'carbon', price: 'price' };

/* All locale fr languages available in browsers */
const frLangLocale = [
    'fr-FR',
    ['fr'],
    'fr',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-LU',
    'fr-MC',
];

const MODES = {
    TEST: 'test',
    PROD: 'prod',
};

/* Spaces available */
const spaces = {
    charity: 'charity',
    climate: 'climate',
};

/*Allowed image formats*/
const imageFormats = ['image/jpeg', 'image/png', 'image/svg+xml'];

/* Login account error message modes */
const charityAccountStatus = {
    onGoing: 'onGoing',
    validated: 'validated',
    missingData: 'missingData',
};

/**
 * @description - array of object with countries name and value for country selector for user profile
 * @param {function} t - from i18next
 */
const countryOptions = (t) => {
    return Object.keys(Country)
        .slice(0, Object.keys(Country).length / 2)
        .map((option) => {
            return {
                value: Country[option],
                text: t(`countries:${Country[option]}`),
            };
        });
};

/* Visibility Status for associations */
const visibilityStatus = {
    VISIBLE: 'VISIBLE',
    NOTVISIBLE: 'NOTVISIBLE',
};

export {
    billingDisplayModes,
    carbonModes,
    roleOptions,
    roleOptionsPaygreen,
    roleDefault,
    startOfMonth,
    endOfMonth,
    statusDonations,
    partnershipStatus,
    partnershipGroupStatus,
    apiPartnershipStatus,
    partnershipGroupFormModes,
    accountErrorModes,
    statusSepa,
    statusActivation,
    statusSpaces,
    frLangLocale,
    MODES,
    spaces,
    localLoginStatus,
    imageFormats,
    countryOptions,
    stripeAccountActivation,
    stripeAccountModes,
    charityAccountStatus,
    visibilityStatus,
};
